// Auth provider configuration
import { AUTH_PROVIDERS } from '@/consts/auth.consts';
import { isFigmaEmbedContext } from '@/utils/auth.utils';
import type { AuthProvider } from '@/services/auth/authProvider.types';

interface AuthConfig {
  provider: AuthProvider;
}

export const useAuthConfig = (): AuthConfig => {
  if (isFigmaEmbedContext()) {
    return {
      provider: AUTH_PROVIDERS.FIGMA_EMBED,
    };
  }
  return {
    provider: AUTH_PROVIDERS.FIREBASE,
  };
};
